import createjs from 'preload-js';

export default {
	state: {
		loader: new createjs.LoadQueue(),
		manifestKey: "critical",
		loaded: false,
		xhr: false,
		completionAction: "loadIntroScreen",
	},
	mutations: {
		loadManifest(state, payload) {
			state.manifestKey = payload.key || state.manifestKey;
			state.loader.useXHR = state.xhr;
			state.loader.loadManifest(payload.manifest);
			state.loader.load();
		},
		setCompletionAction(state, payload) {
			state.completionAction = payload.action;
		},
		setXHR(state, payload) {
			state.xhr = payload.xhr;
		},
	},
	getters: {
		isLoaded(state) {
			return () => state.loader.loaded;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/assets.js